import { useSelector } from 'react-redux';

import { createSelector } from '@reduxjs/toolkit';

import { selectAppUi } from '@/reducers/common/selectors';

const selectData = createSelector(selectAppUi, (appUi) => appUi as Record<string, string>);

const useAppUiData = () => useSelector(selectData);

export default useAppUiData;
